/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ScheduleRecurrenceRule,
  ScheduleRecurrenceRule$inboundSchema,
  ScheduleRecurrenceRule$Outbound,
  ScheduleRecurrenceRule$outboundSchema,
} from "./schedulerecurrencerule.js";

/**
 * An event in a schedule
 */
export type ScheduleEvent = {
  /**
   * The recurrence rule of a schedule event
   */
  rrule: ScheduleRecurrenceRule;
  /**
   * The start date of the event
   */
  startDate?: Date | undefined;
};

/** @internal */
export const ScheduleEvent$inboundSchema: z.ZodType<
  ScheduleEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  rrule: ScheduleRecurrenceRule$inboundSchema,
  start_date: types.optional(types.date()),
}).transform((v) => {
  return remap$(v, {
    "start_date": "startDate",
  });
});
/** @internal */
export type ScheduleEvent$Outbound = {
  rrule: ScheduleRecurrenceRule$Outbound;
  start_date?: string | undefined;
};

/** @internal */
export const ScheduleEvent$outboundSchema: z.ZodType<
  ScheduleEvent$Outbound,
  z.ZodTypeDef,
  ScheduleEvent
> = z.object({
  rrule: ScheduleRecurrenceRule$outboundSchema,
  startDate: z.date().transform(v => v.toISOString()).optional(),
}).transform((v) => {
  return remap$(v, {
    startDate: "start_date",
  });
});

export function scheduleEventToJSON(scheduleEvent: ScheduleEvent): string {
  return JSON.stringify(ScheduleEvent$outboundSchema.parse(scheduleEvent));
}
export function scheduleEventFromJSON(
  jsonString: string,
): SafeParseResult<ScheduleEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ScheduleEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ScheduleEvent' from JSON`,
  );
}
